/* 
  this.$tipsDialog(
    "提示",
    "确定删除吗？",
    "确定后将删除...",
    "el-icon-warning",
    "rgb(255, 178, 60)"
  ).then(() => {
    console.log('confirm')
  }).catch(() => {
    console.log('cancel')
  });
*/
import './tipsDialog.css'
const TipsDialog = {
  install: function (Vue) {
    Vue.prototype.$tipsDialog = function alert(
        title = "提示",
        msg = "是否删除",
        content = "是否删除当前项",
        iconType = "el-icon-warning", //图标类型
        iconColor = "#ccc", //图标颜色
        settings = {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
    ) { 
      Object.assign(settings, {
        dangerouslyUseHTMLString: true,
        customClass: 'el_tips_dialog',
        closeOnClickModal: false,
        showClose: false
      });
      return this.$confirm(`<div class="tips_dialog_content" style="text-align: center;">
          <i class=${iconType} style="color:${iconColor}"></i>
          <p>
            <span>${msg}</span>
            <span>${content}</span>
          </p>
        </div> `, title, settings, msg, content, iconType, iconColor );
    };
  }
}

export default TipsDialog



// WEBPACK FOOTER //
// ./src/components/tipsDialog/index.js